module.exports = __webpack_public_path__ + "static/media/upper-arrow.8fa2b189.svg";